import { DEFAULT_ANIMATE_SETTINGS } from '../constants'

export const initialAnimateSettingsState = {
  animateSettings: { ...DEFAULT_ANIMATE_SETTINGS },
}
